export enum FormalitySupervisorEnum {
  alexLegal = 'alex_legal',
  monFormaliste = 'mon_formaliste',
  interne = 'interne'
}
